export const validateABNorACN = (value) => {
    const numStr = value?.toString().replace(/\s+/g, '') // Remove any spaces
    if (numStr?.length === 11) {
        //setTypeSelected('ABN')
        // Place additional ABN validation logic here if needed
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]

        // Remove any spaces in the ABN
        value = value.replace(/\s+/g, '')

        // ABN must be 11 digits long
        if (value.length !== 11 || isNaN(value)) {
            return false
        }

        // Apply the ABN weighting system
        let sum = 0
        for (let i = 0; i < weights.length; i++) {
            // Subtract 1 from the first digit according to the specification
            let digit = i === 0 ? parseInt(value[i], 10) - 1 : parseInt(value[i], 10)
            sum += weights[i] * digit
        }

        // Valid ABN will have a sum that is divisible by 89
        return sum % 89 === 0
    } 
    else if (numStr?.length === 9) {
        return isValidACN(value)
    }
   return false
}

export const isValidACN = (acn) => {
    const weights = [8, 7, 6, 5, 4, 3, 2, 1]

    // Remove any spaces or non-numeric characters
    acn = acn.replace(/\s+/g, '').replace(/[^0-9]/g, '')

    // ACN must be 9 digits long
    if (acn.length !== 9 || isNaN(acn)) {
        return false
    }

    let sum = 0
    for (let i = 0; i < weights.length; i++) {
        let digit = parseInt(acn[i], 10)
        sum += weights[i] * digit
    }

    // Calculate the check digit
    const checkDigit = (10 - (sum % 10)) % 10

    // The check digit is the last digit in the ACN
    return checkDigit === parseInt(acn[8], 10)
}